import React from "react";

export const WelcheSendungen: React.FC = () => {
  return (
    <div className='faq-which-shipment-wrapper'>
      <p>
        Grundsätzlich lassen sich lediglich nachweispflichtige Sendungen von der
        Einlieferung bis zur Zustellung nachverfolgen. Dazu zählen folgende
        Sendungen:{" "}
      </p>

      <ul className='link-tick-icon'>
        <li>Einschreiben-Einwurf</li>
        <li>Einschreiben-Übergabe</li>
        <li>Einschreiben-Persönlich</li>
        <li>Einschreiben-Rückschein</li>
        <li>Einschreiben-Persönlich-Rückschein</li>
        <li>Postzustellaufträge</li>
        <li>Pakete</li>
        <li>Amazon-Prime-Sendungen&nbsp;</li>
      </ul>
      <br />
      <p>
        <strong>
          Bitte beachten Sie, dass sich „normale“ Amazon-Sendungen (Nicht-Prime)
          nicht nachverfolgen lassen.
        </strong>
      </p>
    </div>
  );
};
